export const FRAME_HEIGHT = 64;
export const FRAME_ID = 'apple-pay';

export const APPLE_PAY_REQUEST = {
  country: 'US',
  currency: 'usd',
  label: 'Sweetgreen',
  requestPayerName: true,
  requestPayerEmail: true,
};
